import React, {Component} from 'react'
import '../../../styles/Admin.css'
import {Button} from "react-bootstrap";
import {Editor} from 'react-draft-wysiwyg'
import {ContentState, convertFromHTML, convertToRaw, EditorState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import AdminGaleria from "../AdminGaleria";
import Modal from "react-modal";


export default class EdytujWpis extends Component {

    constructor(props) {
        super(props);

        let zdjecia = [];

        for (let i = 0; i < this.props.item.zdjecia.length; i++) {
            if (this.props.item.zdjecia[i].obrazek !== null) {
                zdjecia.push(this.props.item.zdjecia[i])
            }
        }

        let tresc = EditorState.createEmpty();

        if (this.props.item.tresc !== null && this.props.item.tresc !== '') {
            const blocksFromHTML = convertFromHTML(
                this.props.item.tresc
            );

            const content = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap
            );

            tresc = EditorState.createWithContent(content);
        }

        this.state = {
            tytul: this.props.item.tytul,
            tresc: tresc,
            opis: '',
            modalIsOpen: false,
            zdjecie: [],
            zdjecieShow: zdjecia,
            opublikowano: this.props.item.opublikowano,
        };

        this.handleTytulChange = this.handleTytulChange.bind(this);
        this.handleTrescChange = this.handleTrescChange.bind(this);
        this.handleOpisChange = this.handleOpisChange.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }


    onEditorStateChange = (editorState) => {
        this.setState({
            tresc: editorState,
        });
    };

    handleTytulChange(e) {
        this.setState({tytul: e.target.value})
    }

    handleTrescChange(e) {
        this.setState({tresc: e.target.value})
    }

    handleOpisChange(e) {
        this.setState({opis: e.target.value})
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({zdjecieInvalid: true, zdjecie: '', zdjecieShow: ''})
        } else {
            this.setState({zdjecieInvalid: false, zdjecie: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState(prevState => ({
                zdjecieShow: [...prevState.zdjecieShow, {
                    obrazek: reader.result,
                    opis: this.state.opis
                }]
            }));
            this.setState({zdjecie: '', opis: ''})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    deleteImage(image) {
        let images = this.state.zdjecieShow;
        images = images.filter(el => el !== image);
        this.setState({zdjecieShow: images})
    }

    uploadNews() {
        let aktualnosci = [];
        let zdjecia = [];

        for (let i = 0; i < 3; i++) {
            if (this.state.zdjecieShow[i] === undefined) {
                zdjecia.push({obrazek: null, opis: null})
            } else {
                zdjecia.push(this.state.zdjecieShow[i])
            }
        }
        aktualnosci = JSON.parse(localStorage.getItem('aktualnosci'));
        aktualnosci = aktualnosci.filter(el => el.id !== this.props.item.id);
        aktualnosci.push({
            id: this.props.item.id,
            autor: 'ADMIN',
            data: this.props.item.data,
            opublikowano: this.state.opublikowano,
            tytul: this.state.tytul,
            tresc: draftToHtml(convertToRaw(this.state.tresc.getCurrentContent())),
            zdjecia: zdjecia
        });
        localStorage.setItem('aktualnosci', JSON.stringify(aktualnosci));
        this.props.goZarzadzanie()
    }

    render() {
        return <div className="aktualnosciTabContainer">
            <Modal
                isOpen={this.state.modalIsOpen}
                onRequestClose={this.closeModal}
                contentLabel="Biblioteka mediów"
                style={{
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                }}
            >
                <AdminGaleria modal={true} container={true} closeModal={() => this.closeModal()}
                              wybierzObraz={(obraz) => {
                                  this.setState(prevState => ({
                                      zdjecieShow: [...prevState.zdjecieShow, {
                                          obrazek: obraz.zdjecia.src,
                                          opis: obraz.zdjecia.name
                                      }]
                                  }));
                                  this.closeModal()
                              }}/>
            </Modal>
            <div className="aktualnosciOpis">
                Aby edytować wpis należy zmienić wybrane do zmiany pola, oraz zdjęcia. Wpis można później edytować
                ponownie
                przez zakładkę
                <span style={{cursor: 'pointer'}} onClick={() => this.props.goZarzadzanie()}>
                    <b> zarządzanie</b>
                </span>.
            </div>
            <div className="nowyWpisForm">
                <div className="field">Tytuł:
                    <input type="text" value={this.state.tytul} onChange={this.handleTytulChange}
                           className="form-control"/></div>
                <div className="field">Treść:
                    <Editor
                        editorState={this.state.tresc}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperEditor"
                        editorClassName="editorEditor"
                        onEditorStateChange={this.onEditorStateChange}
                    /></div>
                <div className="field">
                    <div className="row">
                        <div className="col-sm-6">
                            Dodaj zdjęcia:
                            <div onClick={this.state.zdjecieShow.length < 3 ? () => this.openModal() : null}
                                 style={{
                                     marginTop: 15,
                                     height: 150,
                                     width: '90%',
                                     padding: 50,
                                     textAlign: 'center',
                                     border: '1px dashed #ced4da',
                                     borderRadius: '.25rem',
                                     cursor: 'pointer'
                                 }}>
                                {this.state.zdjecieShow.length < 3 ? 'Kliknij by otworzyć menedżer plików' : 'Osiągnięto maksymalną ilość obrazków dla wpisu (3)'}</div>
                        </div>
                        <div className="col-sm-6" style={{borderLeft: '1px solid #eaeaea'}}>
                            Dodane zdjęcia:
                            <div className={'row'}>
                                {this.state.zdjecieShow.map((item, i) => {
                                    return <div className='col-4 text-center imageBorderNowyWpis'>
                                        <i className="fa fa-times"
                                           style={{color: 'red', float: 'right', paddingTop: 10, cursor: 'pointer'}}
                                           onClick={() => this.deleteImage(item)}> </i>
                                        <img src={item.obrazek} width={'100%'}/>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="text-right">
                    <span style={{width: 105, textAlign: 'center'}}>Publikacja:
                        <input type={'checkbox'} style={{marginLeft: 5, marginRight: 10, paddingTop: 3}}
                               checked={this.state.opublikowano}
                               onChange={() => this.setState({opublikowano: !this.state.opublikowano})}/>
                    </span>
                    <Button bsStyle={'success'} onClick={() => this.uploadNews()}>Aktualizuj wpis</Button>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/galeriaComponents/EdytujWpis.js